export const mycoupon = {
    title: 'My Coupon',
    tab_available: 'Valid',
    tab_expired: 'Invalid',
    ExpireDate : 'Expire on : ',
    UsePoint : 'Used Points : ',
    GetPoint : 'GetPoint',
    Status: 'Status :',
    Status_Expired: 'Expire',
    tab_subscription: 'Subscription',
}
